import React from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

export function CustomerIdColumnFormatter(customerID, greenInvoiceClientID) {

  return (
    <div className={'d-flex align-items-center justify-content-between'}>
      <span className={'text-dark-75 font-weight-bolder font-size-h5'}>{customerID}</span>
      {greenInvoiceClientID &&
        <img src={toAbsoluteUrl('/media/common/GI-logo.svg')} alt="icon" className={'ml-2 mr-10 w-20px h-20px'}/>
      }
    </div>
  );
}
